<template>
  <div class="ls-badge" :class="themedClass">
    <div
      :class="[
        themedClass.length ? bgColor : `has-background-${bgColor}`,
        [rounded ? 'ls-badge--badge-rounded' : 'ls-badge--badge-default'],
      ]"
      class="ls-badge--badge"
    >
      {{ label }}
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import { lsColors } from '@/constants';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'LsBadge',
  mixins: [themedComponentMixin],
  props: {
    label: VueTypes.string.isRequired,
    bgColor: VueTypes.oneOf(_.keys(lsColors)).def('primary'),
    rounded: VueTypes.bool.def(true),
  },
};
</script>

<style lang="scss" scoped>
.ls-badge {
  display: inline-block;

  &.themed-component {
    .ls-badge--badge {
      color: $theme-color-white;
      font-size: var(--theme-txt-help);

      &.primary {
        background: $theme-color-primary;
      }

      &.secondary {
        color: $theme-color-primary;
        background: $theme-color-primary-light;
      }

      &.tertiary {
        color: $theme-color-secondary-button-text;
        background: $theme-color-secondary;
      }
    }
  }
}
.ls-badge--badge-rounded {
  border-radius: 10px;
}
.ls-badge--badge-default {
  border-radius: 2px;
}
.ls-badge--badge {
  line-height: 1;
  font-weight: bold;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: $white;
  font-size: $size-7;
  padding: 5px 9px 3px;
}
</style>
